import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadOption } from '../../interfaces/upload.interface';

@Component({
  selector: 'app-upload-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './upload-dropdown.component.html',
  styleUrl: './upload-dropdown.component.css'
})
export class UploadDropdownComponent {
  @Output() optionSelected = new EventEmitter<UploadOption>();

  uploadOptions: UploadOption[] = [
    {
      id: 'document',
      label: 'Document',
      icon: 'assets/icons/document-icon.svg'
    },
    {
      id: 'chunk',
      label: 'Text',
      icon: 'assets/icons/chunk-icon.svg'
    }
  ];

  onOptionClick(option: UploadOption): void {
    this.optionSelected.emit(option);
  }
}
